import { render, staticRenderFns } from "./ToolBar.vue?vue&type=template&id=35d3b0c1&scoped=true&"
import script from "./ToolBar.vue?vue&type=script&lang=js&"
export * from "./ToolBar.vue?vue&type=script&lang=js&"
import style0 from "./ToolBar.vue?vue&type=style&index=0&id=35d3b0c1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d3b0c1",
  null
  
)

export default component.exports